import { TooltipProps } from "@blueprintjs/core";
import React, { ReactNode } from "react";
import styled from "styled-components";

import { HexTooltip } from "../../hex-components";

import { UserAvatar, UserProps } from "./UserAvatar";

const TooltipContentDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 3px 0;

  font-size: ${({ theme }) => theme.fontSize.SMALL};
`;

const TooltipMetaDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: 8px;
`;

const TooltipNameDiv = styled.div`
  color: ${({ theme }) => theme.fontColor.DEFAULT};
`;

const TooltipEmailDiv = styled.div`
  margin-top: 3px;
  padding-bottom: 2px;

  line-height: 10px;
`;

export interface UserTooltipProps extends UserProps {
  children?: ReactNode;
  tooltipRenderTarget?: TooltipProps["renderTarget"];
  toolTipTargetTagName?: TooltipProps["targetTagName"];
  tooltipPosition?: TooltipProps["position"];
}

/**
 * Display user information + avatar in a tool tip.
 */
export const UserTooltip: React.ComponentType<UserTooltipProps> = React.memo(
  function UserTooltip({
    children,
    toolTipTargetTagName,
    tooltipPosition,
    tooltipRenderTarget,
    ...userProps
  }) {
    return (
      <HexTooltip
        content={<UserTooltipContent {...userProps} />}
        position={tooltipPosition}
        renderTarget={tooltipRenderTarget}
        targetTagName={toolTipTargetTagName}
      >
        {children}
      </HexTooltip>
    );
  },
);

export const UserTooltipContent = React.memo(function UserTooltipContent(
  userProps: UserProps,
) {
  return (
    <TooltipContentDiv>
      <UserAvatar {...userProps} tooltip={false} />
      <TooltipMetaDiv>
        {userProps.name && <TooltipNameDiv>{userProps.name}</TooltipNameDiv>}
        {userProps.email && (
          <TooltipEmailDiv>{userProps.email}</TooltipEmailDiv>
        )}
      </TooltipMetaDiv>
    </TooltipContentDiv>
  );
});
